module.exports = __webpack_public_path__ + "img/skull_process.a04433fd.png";